import utils from '../utils.js';
import httpAdapter from './http.js';
import xhrAdapter from './xhr.js';
import AxiosError from '../core/AxiosError.js';
var knownAdapters = {
    http: httpAdapter,
    xhr: xhrAdapter
};
utils.forEach(knownAdapters, function (fn, value) {
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', { value: value });
        } catch (e) {
        }
        Object.defineProperty(fn, 'adapterName', { value: value });
    }
});
export default {
    getAdapter: function getAdapter(adapters) {
        adapters = utils.isArray(adapters) ? adapters : [adapters];
        var _adapters = adapters, length = _adapters.length;
        var nameOrAdapter;
        var adapter;
        for (var i = 0; i < length; i++) {
            nameOrAdapter = adapters[i];
            if (adapter = utils.isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) {
                break;
            }
        }
        if (!adapter) {
            if (adapter === false) {
                throw new AxiosError('Adapter '.concat(nameOrAdapter, ' is not supported by the environment'), 'ERR_NOT_SUPPORT');
            }
            throw new Error(utils.hasOwnProp(knownAdapters, nameOrAdapter) ? 'Adapter \''.concat(nameOrAdapter, '\' is not available in the build') : 'Unknown adapter \''.concat(nameOrAdapter, '\''));
        }
        if (!utils.isFunction(adapter)) {
            throw new TypeError('adapter is not a function');
        }
        return adapter;
    },
    adapters: knownAdapters
};